import { PrismicRichText } from '@prismicio/react';
import { Fragment, ReactElement } from 'react';

import { IProps } from './types';
import * as S from './styles';

export function SliceBlogContentTextText({
  slice: { fields },
}: IProps): ReactElement {
  const renderContent = fields ? (
    <S.Wrapper className="slice-item blog-text-text">
      {fields.map((item, i) => (
        <Fragment key={i}>
          <S.Paragraph className="blog-text-text__paragraph">
            {item.content_text_left && (
              <PrismicRichText field={item.content_text_left} />
            )}
          </S.Paragraph>
          <S.Paragraph className="blog-text-text__paragraph">
            {item.content_text_right && (
              <PrismicRichText field={item.content_text_right} />
            )}
          </S.Paragraph>
        </Fragment>
      ))}
    </S.Wrapper>
  ) : null;

  return renderContent;
}

SliceBlogContentTextText.componentName = 'blog-content-text-text';
